import { render, staticRenderFns } from "./BlackGoldMyPage.vue?vue&type=template&id=5d77070f&"
import script from "./BlackGoldMyPage.vue?vue&type=script&lang=js&"
export * from "./BlackGoldMyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports